import styled from 'styled-components';

import {
  BodyLarge,
  BodyMedium,
  H2,
} from '@/core/components/Typography';
import { MarginWrapper } from '@/core/components/MarginWrapper';

import { breakpoint } from '@/themes/breakpoints';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  min-height: calc(100vh - 92px);
  box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.05);
  padding-top: 50px;

  @media ${breakpoint.md} {
    padding-top: 100px;
  }
`;

export const InputContainer = styled.div`
  margin-top: 16px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`;

export const Content = styled.div`
  flex-grow: 1;
  width: 100%;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  padding-top: 40px;

  @media ${breakpoint.md} {
    padding-top: 80px;
  }
`;

export const Footer = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 248px;
  background-image: url("/assets/images/vectorBackgrounds/grey.svg");
  background-position-x: center;
  background-position-y: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h2`
  ${H2}
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-family: var(--executive-website-heading-font-family);
  text-align: center;
`;

export const Text = styled.p`
  ${BodyMedium}
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral[700]};
  text-align: center;
`;

export const EmptyResults = styled.p`
  ${BodyLarge}
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral[700]};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  text-align: center;

  @media ${breakpoint.md} {
    margin-top: -40px;
    font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  }
`;
